export default __webpack_public_path__ + "static/media/border-bg.114e960d.webp";